<template>
  <div class="simple-add">
    <div class="head">
      <span @click="active = 1" :class="{active: active === 1}">单选</span>
      <span @click="active = 2" :class="{active: active === 2}">多选</span>
    </div>

    <div class="conatiner">
      <div
        v-for="(item, index) in list"
        :key="item"
        class="item"
        :class="[`item${index}`, {active: activeIndex === index}]"
        @click="activeIndex = index"
      >
        <div :class="{radio: active == 1}" class="item-option" v-for="option in item.split(',')" :key="option">
          {{ option }}
        </div>
      </div>
    </div>

    <div class="que-detail-footer">
      <div class="checkbox">
        <van-checkbox shape="square" v-model="checked">允许游客答题</van-checkbox>
      </div>
      <div class="pub-btn">
        <div @click="send" class="edit">发送答题卡</div>
      </div>
    </div>
  </div>
</template>

<script>
import {simpleSend} from '@/api'
// eslint-disable-next-line no-unused-vars
import {wsMixin} from '@/views/activePlay/wsMixin.js'
export default {
  mixins: [wsMixin],
  data() {
    return {
      list: ['A,B', 'A,B,C', 'A,B,C,D', 'A,B,C,D,E'],
      active: 1,
      activeIndex: 0,
      checked: false
    }
  },
  methods: {
    async send() {
      if (!this.wsOpen) {
        return this.$Toast.success('发送失败，请重试')
      }
      const data = {
        chooseCount: this.activeIndex + 2,
        chooseType: this.active,
        eventExamPaperId: this.$route.query.paperId || 0,
        eventId: this.$route.params.id,
        name: '快速答题卡',
        allowVisitors: this.checked ? 1 : 2
      }
      const result = await simpleSend(data)
      if (result.code === 0) {
        const obj = {
          c: 30001,
          a: {
            isCheckbox: this.active, // isCheckbox: 1. 单选 2. 多选
            objectId: result.data, // 答题卡id
            objectType: 2 // type 1. 标准出题  2. 快速出题
          },
          e: this.$route.params.id
        }
        this.ws.send(JSON.stringify(obj))

        this.$Toast.success('发送成功')
        setTimeout(() => {
          this.$router.replace(`/activeQueList/${this.$route.params.id}`)
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.simple-add {
  padding: 10px 10px 100px;
  .head {
    display: flex;
    justify-content: space-around;
    span {
      padding-bottom: 4px;
      border-bottom: 4px solid transparent;
    }
    span.active {
      border-bottom-color: rgba(68, 101, 243, 1);
    }
  }
}

.conatiner {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;
  .item {
    margin-top: 20px;
    background: #fff;
    border-radius: 16px;
    width: 48%;
    height: 90px;
    padding: 20px;
    text-align: center;
    border: 3px solid transparent;
    &.active {
      border-color: #4465f3;
    }
    .item-option {
      display: inline-block;
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #eef0f3;
      color: #333333;
      &.radio {
        border-radius: 50%;
      }
    }
  }
  .item0,
  .item1 {
    display: flex;
    align-items: center;
    justify-content: center;
    .item-option + .item-option {
      margin-left: 20px;
    }
  }
  .item2 {
    padding: 12px 30px;
    .item-option {
      margin-right: 10px;
      margin-bottom: 6px;
    }
  }
  .item3 {
    padding: 12px 20px;
    .item-option {
      margin-right: 6px;
      margin-bottom: 6px;
    }
  }
}

.que-detail-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  .checkbox {
    padding: 6px 6px;
    background: #f4f6f9;
  }
  .pub-btn {
    padding: 0 10px;
    height: 70px;
    background: #fff;
    line-height: 70px;
    div {
      display: inline-block;
      width: 100%;
      height: 45px;
      border-radius: 47px;
      text-align: center;
      line-height: 45px;
      color: #fff;
    }
    div.edit {
      background: rgba(74, 134, 246, 1);
    }
  }
}
</style>
